import React, { useEffect, useState } from "react";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import { ClearOutlined, SearchOutlined } from "@ant-design/icons";
// import { ImageViewer } from "react-image-viewer-dv";
import _ from "lodash";
import { LanguageContext } from "../context/LanguageContext";
import { ImageViewOnly } from "../Pages/image/onlyImageVIew";
import { professionalAction } from "../_actions";

export class SearchCriminal1 extends React.Component {
  static contextType = LanguageContext;
  state = {
    searchText: "",
    searchedColumn: "",
    imageOpen: false,
    selectedImage: null,
    is_search: false,
  };

  searchByCrimeCount = () => {
    const registernumber = this.props.registernumber;
    const selectedPoliceStation = this.props.selectedPoliceStation;
    const body = {
      registernumber: registernumber,
      value: selectedPoliceStation?.value,
      id: selectedPoliceStation.id,
      districtName: this.state.searchText,
    };

    this.setState({
      tableLoading: true,
      is_search: true,
    });
    const searchBody = {
      type: "crime count",
      search_text: `${this.props?.registernumber} ${this.state?.searchText}`,
      userid: this.props.userid,
      district: this.props.district,
      districtName: this.props.districtName,
    };
    professionalAction.postSearchHistory(searchBody).then((res) => {
      console.log("res", res);
    });
    professionalAction.searchByGunhaCount(body).then((res) => {
      res &&
        res.text().then((criminalListAll) => {
          const result = criminalListAll && JSON.parse(criminalListAll);
          let finalList;
          finalList = result?.map((res, index) => {
            return {
              ...res,
              "Sr.No": index + 1,
            };
          });
          this.setState({
            data: finalList,
            totalNew: finalList.length,
            tableLoading: false,
          });
        });
    });
  };
  clearSearch = () => {
    this.setState({
      is_search: false,
      searchText: "",
      data: [],
    });
  };
  openImageModal = (img, id) => {
    this.setState({ imageOpen: true, selectedImage: img, crime_id: id });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleEditForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onEditAccusedForm(data);
    } else {
      this.props.onEdituser(data);
    }
  };

  handlePreventiveViewForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onPreventiveViewAccusedForm(data);
    } else {
      this.props.onPreventiveViewAccusedForm(data);
    }
  };

  handleViewForm = (data) => {
    this.props.onViewAccusedForm(data);
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };
  render() {
    const requiredSearchAndSort = ["name", "districtName", "address"];
    const { t } = this.context;
    const users = this.props.usersData;
    console.log("columns", this.props.columns);
    let columns = this.props.columns.map((res) => {
      if (
        _.filter(requiredSearchAndSort, (o) => o === res.dataIndex) &&
        _.filter(requiredSearchAndSort, (o) => o === res.dataIndex).length
      ) {
        return {
          ...res,
          sorter: (a, b) => {
            return a[res.dataIndex].length - b[res.dataIndex].length;
          },
        };
      } else {
        return {
          ...res,
        };
      }
    });
    console.log("this.props.data", this.props.data);
    // let columns = this.props.columns.map((res) => {
    //   return {
    //     ...res,
    //     ...this.getColumnSearchProps(res.dataIndex),
    //   };
    // });
    columns = [
      {
        title: t("sr.no"),
        key: "sr.no",
        render: (text, record, index) => (
          <Space size="middle">{record["Sr.No"]}</Space>
        ),
      },
      {
        title: t("crime_number"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle">{record.registernumber}</Space>
        ),
      },
      {
        title: t("crime_year"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle">{record.registernumberYear}</Space>
        ),
      },
      {
        title: t("crime_police_station"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle">{record.districtName}</Space>
        ),
      },
      {
        title: t("name"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle" title={record?.masterId}>
            {record.name}
          </Space>
        ),
      },
       {
        title: t("address"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle">
            {record.address}
          </Space>
        ),
      },
      {
        ...{
          title: t("photo"),
          key: "photo",
          filters: [
            {
              text: "फोटो",
              value: 1,
            },
            {
              text: "नाही",
              value: null,
            },
          ],
          onFilter: (value, record) => {
            if (value) {
              return record?.photo && record?.photo?.length
                ? record?.photo[0]?.split(" ")?.length === value
                : null;
            } else {
              return !record?.photo || record?.photo.length === 0;
            }
          },
          render: (text, record) => (
            <Space size="middle">
              {record?.photo ? (
                // <ImageViewer>
                <img
                  style={{ width: 50, height: 50 }}
                  src={
                    "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                    record?.photo
                  }
                  onClick={() => this.openImageModal(record.photo, record.id)}
                ></img>
              ) : (
                // </ImageViewer>
                t("no")
              )}
            </Space>
          ),
        },
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleEditForm(record);
              }}
            >
              {t("update")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record?.masterId);
              }}
            >
              {t("view1")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handlePreventiveViewForm(record?.masterId);
              }}
            >
              {t("preventive")}
            </Button>
          </div>
        ),
      },
    ];

    return (
      <>
        {this.props.data.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                textAlign: "right",
                display: "flex",
                alignItems: "flex-end",
                gap: "8px",
                marginBottom: "10px",
              }}
            >
              <span>{t("search")}:</span>
              <Input
                placeholder="Search..."
                value={this.state.searchText}
                onChange={this.handleInputChange}
                style={{
                  flex: 1,
                  borderRadius: "6px",
                  minWidth: 250,
                  maxWidth: 250,
                  textAlign: "right",
                }}
                allowClear
              />
              <div style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
                {!this.state.is_search && this.state.searchText && (
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={this.searchByCrimeCount}
                    className="modern-button modern-button-success"
                  >
                    {t("find")}
                  </Button>
                )}
                {this.state.is_search && (
                  <Button
                    onClick={() => this.clearSearch()}
                    icon={<ClearOutlined />}
                    className="modern-button modern-button-danger"
                  >
                    {t("clear")}
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}

        {this.state.is_search ? (
          <Table
            columns={columns}
            dataSource={this.state.data}
            loading={this.state.tableLoading}
          />
        ) : (
          <Table
            columns={columns}
            dataSource={this.props.data}
            pagination={{
              current: this.props.currentPage,
              pageSize: this.props.pageSize,
              total: this.props.total,
              onChange: this.props.handlePageChange,
              has_previous: this.props.pageSize > 1,
              previous: this.props.pageSize - 1,
              has_next: this.props.pageSize < this.props.total,
              next: this.props.total + 1,
              last_page: Math.ceil(this.props.total / this.props.pageSize),
              onShowSizeChange: this.props.handlePageSizeChange,
            }}
            loading={this.props.tableLoading}
          />
        )}

        {this.state.imageOpen && (
          <ImageViewOnly
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            onClose={this.closeImageModal}
            id={this.state.crime_id}
          />
        )}
      </>
    );
  }
}
